import { useAuth0 } from '@auth0/auth0-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  AdminGuard,
  ExternalGuard,
  MasterGuard,
  UserGuard,
} from '@/components/access-guards'

export function ProfileDropdown() {
  const { user, isAuthenticated, isLoading, logout } = useAuth0()

  if (isLoading) {
    return <div>Loading...</div> // Show a loading state
  }

  if (!isAuthenticated) {
    return null // Don't show the dropdown if the user isn't authenticated
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' className='relative h-8 w-8 rounded-full'>
          <Avatar className='h-8 w-8'>
            <AvatarImage src={user?.picture} alt={user?.name || 'User'} />
            <AvatarFallback>
              {user?.name ? user.name[0].toUpperCase() : 'U'}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-56' align='end' forceMount>
        <DropdownMenuLabel className='font-normal'>
          <div className='flex flex-col space-y-1'>
            <p className='text-sm font-medium leading-none'>{user?.name}</p>
            <p className='text-xs leading-none text-muted-foreground'>
              {user?.email}
            </p>
          </div>
        </DropdownMenuLabel>
        {/*<DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link to='/settings'>
              Profile
              <DropdownMenuShortcut>⇧⌘P</DropdownMenuShortcut>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to='/settings'>
              Billing
              <DropdownMenuShortcut>⌘B</DropdownMenuShortcut>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to='/settings'>
              Settings
              <DropdownMenuShortcut>⌘S</DropdownMenuShortcut>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem>New Team</DropdownMenuItem>
        </DropdownMenuGroup>*/}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => (window.location.href = 'https://wa.me/5511986063191')}
        >
          Suporte
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <MasterGuard>
          <Badge className='bg-red-500 text-white'>Master</Badge>
        </MasterGuard>
        <AdminGuard>
          <Badge className='bg-orange-500 text-white'>Admin</Badge>
        </AdminGuard>
        <UserGuard>
          <Badge className='bg-blue-500 text-white'>User</Badge>
        </UserGuard>
        <ExternalGuard>
          <Badge className='bg-green-500 text-white'>External</Badge>
        </ExternalGuard>
        <DropdownMenuItem
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
        >
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
